import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from '@mui/material/Pagination';
import { PRESUPUESTOS_API } from '../shared/services/presupuestos';
import Header from '../shared/components/Header';
import { faLink, faClock, faCheck, faCross, faEnvelope, faCopy, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmModal from "../shared/components/ConfirmModal";
import { fetchPresupuestos, updatePresupuestosState } from "../../../../redux/presupuestos";
import { handleCopyPresupuestoText, isBoolean, isWithFaros, isWithParagolpes, isWithTurbo, setErrorMessage } from "../shared/helpers/functionalities";
import { Popover } from "@mui/material";
import ExportForm from "../shared/components/ExportForm";
import InfoModal from "../shared/components/InfoModal";
import ValidacionModal from "./components/ValidacionModal";
import ProblemasList from "./components/ProblemasList";
import { INTEGRACIONES_API } from "../shared/services/piezas";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "./actions";
import config from "../../../../config";
import PlantillaEmailModal from "./components/PlantillaEmailModal";
import { ObservacionesComercial } from './components/ObservacionesComercial';
import TicketsModal from './components/TicketsModal';
import { TICKETS_API } from '../shared/services/tickets';
import useTicketListener from '../../../../hooks/useTicketListener';
import PartNotFoundModal from "./components/PartNotFoundModal";

export default function Presupuestos({
  ecommerce,
  soporte
}) {
  const user = JSON.parse(localStorage.getItem('user'));
  const dispatch = useDispatch();
  const { page } = useParams();
  const currPage = parseInt(page);
  let navigate = useNavigate(); 
  const [currentPresupuesto, setCurrentPresupuesto] = useState(null);
  const [currentPage, setPage] = useState(currPage);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [isDisabling, setIsDisabling] = useState(false);
  const [isReactivating, setIsReactivating] = useState(false);
  const [showValidate, setShowValidate] = useState(false);
  const [showInvalidate, setShowInvalidate] = useState(false);
  const [isOpenExport, setIsOpenExport] = useState(false);
  const [isOpenObservacionesComercial, setIsOpenObservacionesComercial] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  let presupuestoAux = {};
  const open = Boolean(anchorEl);
  const [openPlantillaEmail, setOpenPlantillaEmail] = useState(false);
  const [isTicketsOpen, setIsTicketsOpen] = useState(null);
  const [isUnasignTicketOpen, setIsUnasignTicketOpen] = useState(null);
  const [isPartNotFoundOpen, setIsPartNotFoundOpen] = useState(null);
  const presupuestos = useSelector(state => state.presupuestos);
  const searcher = useSelector((state) => state.search);
  const plantillasEmail = useSelector(state => state.plantillas_email);
  const ticketCount = useTicketListener(user?.id);

  useEffect(() => {
    dispatch(fetchPresupuestos(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? '&ecommerce=' + ecommerce
        + `&key=${searcher.key}&search=${searcher?.search ? searcher?.search : ''}`
        + (searcher?.start_date ? '&start_date=' + searcher?.start_date : '')
        + (searcher?.end_date ? '&end_date=' + searcher?.end_date : '')
        + (searcher?.min ? '&min=' + searcher?.min : '')
        + (searcher?.max ? '&max=' + searcher?.max : '')
        + (searcher?.responsable ? '&responsable=' + searcher?.responsable : '')
        + (isBoolean(searcher.contiene_casco) ? '&contiene_casco=' + searcher?.contiene_casco : '')
        + (searcher?.casco ? '&casco=' + searcher?.casco : '')
      : '&ecommerce=' + ecommerce;
    if(soporte) {
      query += '&soporte=' + soporte
    }
    return query;
  }

  const handleSearch = (searchData) => {
    setPage(1);
    dispatch({type: "search/set", payload: searchData}); 
  }

  const getBasePath = () => {
    if(ecommerce) return 'ecommerce';
    if(soporte) return 'closer';
    return 'presupuestos'
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const basePath = getBasePath();
    navigate(`/${basePath}/${newPage}`);
    dispatch(fetchPresupuestos(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = presupuestos?.total_items < 15 ? 1 : Math.ceil(presupuestos?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, presupuesto) => {
    if(action === 'details') {
      navigate(`/presupuesto/${presupuesto.id}`);
    } else if(action === 'download') {
      generarPDF(presupuesto)
    } else if(action === 'clone') {
      duplicate(presupuesto)
    } else if(action === 'enable') {
      reactivate(presupuesto)
    } else if(action === 'disable') {
      disable(presupuesto)
    } else if(action === 'validate') {
      handleOpenValidate(presupuesto)
    } else if(action === 'invalidate') {
      handleOpenInvalidate(presupuesto);
    } else if(action === 'assign-ticket') {
      handleOpenAssignTicket(presupuesto);
    } else if(action === 'unassign-ticket') {
      handleOpenUnassignTicket(presupuesto)
    }
  }

  const generarPDF = async (presupuesto) => {
    dispatch({type: 'loading/set', payload: true});
    const pdfResult = await PRESUPUESTOS_API.getPDF(presupuesto.id);

    if(pdfResult) {
      toast.success('PDF generado correctamente!')
      const url = window.URL.createObjectURL(new Blob([pdfResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', presupuesto.numero + '.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    dispatch({type: 'loading/set', payload: false});
  }

  const reactivate = (presupuesto) => { 
    setCurrentPresupuesto(presupuesto);
    setIsReactivating(true);
  }

  const handleConfirmReactivate = async (confirm) => {
    if (confirm) {
      dispatch({type: 'loading/set', payload: true});
      const activateResult = await PRESUPUESTOS_API.enable(currentPresupuesto.id)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });

      if(activateResult && activateResult.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(activateResult.message)
        dispatch(fetchPresupuestos(currPage, getQuery()));
      }
    }

    setIsReactivating(false);
  }

  const disable = (presupuesto) => {
    setCurrentPresupuesto(presupuesto);
    setIsDisabling(true);
  }

  const handleConfirmDisable = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const disableResult = await PRESUPUESTOS_API.disable(currentPresupuesto.id)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });

      if(disableResult && disableResult.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(disableResult.message)
        dispatch(fetchPresupuestos(currPage, getQuery()));
      }
    }

    setIsDisabling(false);
  }

  const handleConfirmValidate = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const result = await PRESUPUESTOS_API.validate({validado: true, validacion: confirm}, currentPresupuesto.id)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });
  
      if(result && result.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(result.message)
        dispatch(fetchPresupuestos(currPage, getQuery()));
      }
    } 
    
    handleCloseValidate();
  }
  
  const handleOpenAssignTicket = (pres) => { setIsTicketsOpen(true); setCurrentPresupuesto(pres); }
  const handleCloseAssignTicket = () => { setIsTicketsOpen(false); setCurrentPresupuesto(null); }

  const handleOpenUnassignTicket = (pres) => {setIsUnasignTicketOpen(true); setCurrentPresupuesto(pres);}
  const handleCloseUnassignTicket = () => {setIsUnasignTicketOpen(false); setCurrentPresupuesto(null);}
  const handleConfirmUnasignTicket = async (confirm) => {
    if(confirm) {
      try {
        dispatch({type: 'loading/set', payload: true});
        const res = await TICKETS_API.unassign(currentPresupuesto.ticket_id);
        if(res.success) {
          dispatch(updatePresupuestosState(presupuestos, currentPresupuesto.id))
          return toast.success('Ticked desasignado correctamente!');
        }
        toast.error('Algo ha ido mal...');
      } catch (e) {
        toast.error(e.message);
      } finally {
        dispatch({type: 'loading/set', payload: false});
      }

    }
    handleCloseUnassignTicket()
  }

  const handleOpenValidate = (pres) => { setShowValidate(true); setCurrentPresupuesto(pres); }
  const handleCloseValidate = () => { setShowValidate(false); setCurrentPresupuesto(null); }

  const duplicate = (presupuesto) => { 
    setCurrentPresupuesto(presupuesto);
    setIsDuplicating(true);
  }

  const handleConfirmDuplicate = async (confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const duplicateResult = await PRESUPUESTOS_API.duplicate(currentPresupuesto.id)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });

      if(duplicateResult && duplicateResult.success) {
        dispatch({type: 'loading/set', payload: false});
        setIsDuplicating(false);
        toast.success(duplicateResult.message)
        dispatch(fetchPresupuestos(currPage, getQuery()));
      } 
    } else {
      setIsDuplicating(false);
    }
  }

  const handleCopyText = (presupuesto) => {
    if(presupuesto.validado) {
      const text = handleCopyPresupuestoText(presupuesto, user);

      navigator.clipboard.writeText(text);
      toast.success('Texto copiado!');

      if(isWithParagolpes(presupuesto?.piezas)) {
        toast.warning(`Verificar los componentes que lleva montados el paragolpes para que al 
        cliente le llegue lo mismo que en las fotos, preguntarlo por escrito al desguace.`);
      }
  
      if(isWithFaros(presupuesto?.piezas)) {
        toast.warning(`En el caso de un faro de xenon o led, verificar si el faro viene con las centralitas, 
        informar al cliente para que no haya mal entendidos. Preguntarlo por escrito al desguace.`);
      }

      if(isWithTurbo(presupuesto?.piezas)) {
        toast.warning(`Recuerda pedir un video al desguace donde se vea el juego axial y radial del eje del turbo, 
        es importante conseguir el video antes de la venta del turbo para evitar una posible incidencia, 
        los turbos presentan una incidencia aprox. del 40%.`);
      }
    } else {
      toast.error("¡¡PRESUPUESTO NO VALIDADO!! 😛🖕🏼");
    }
  }

  const handleCopyTextCheckoutDiscount = (presupuesto) => {
    const text = `Buenas, te hablo de Recomotor, según comentado por teléfono, te mando el presupuesto ${
      presupuesto?.numero
    }, con el 10% de descuento adicional al recambio de ${
      presupuesto.piezas.map(pieza => pieza.nombre).join(', ')
    }. Puedes entrar en el siguiente enlace para tramitar la compra: ${
      config.recomotor.clientsUrl  + 'checkout/' + presupuesto.checkout_id
    }. Cualquier duda me puedes hablar por aquí. Un saludo.`
    navigator.clipboard.writeText(text);
    toast.success('Texto copiado!');
  }

  const handleGoToEnvio = (envio) => {
    dispatch({type: "search/set", payload: {search: envio.codigo_transporte, key: 'envio' }});
    navigate('/envios/1', { replace : true});
  }

  const handleGoToEcommerce = () => {
    setPage(1);
    dispatch({type: "search/set", payload: {}});
    navigate('/ecommerce/1', { replace : true});
  }

  const handleGoToPresupuestos = () => {
    setPage(1);
    dispatch({type: "search/set", payload: {}});
    navigate('/presupuestos/1', { replace : true});
  }

  const handlePopoverOpen = (event, pres) => { 
    setAnchorEl(event.currentTarget); 
    presupuestoAux = pres;
  };
  const handlePopoverClose = () => { setAnchorEl(null); };

  const handleOpenExport = () => { setIsOpenExport(true); }
  const handleCloseExport = () => { setIsOpenExport(false); }
  const handleExportPresupuestosClientes = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const cliente = data.cliente;
    delete data.cliente;
    data.entity_id = cliente.id;
    const excelResult = await PRESUPUESTOS_API.exportByEntity(data);
    const startDate = moment(data.startDate).format('DD-MM-YYYY');
    const endDate = moment(data.endDate).format('DD-MM-YYYY');

    if(excelResult) {
      dispatch({type: 'loading/set', payload: false});
      toast.success('PDF generado correctamente!')
      const url = window.URL.createObjectURL(new Blob([excelResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', cliente.nombre + '_' + startDate + '_' + endDate + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
  }

  const handleMarkProblemAsRead = async(problemaId) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await INTEGRACIONES_API.markProblemAsRead(problemaId);

    if(response && response.success) {
      dispatch({type: 'loading/set', payload: false});
      toast.success(response.message)
      dispatch(fetchPresupuestos(currPage, getQuery()));
    }
  }

  const handleOpenInvalidate = (pres) => { setShowInvalidate(true); setCurrentPresupuesto(pres); }
  const handleConfirmInvalidate = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const result = await PRESUPUESTOS_API.validate({validado: false, validacion: null}, currentPresupuesto.id)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
        dispatch({type: 'loading/set', payload: false});
      });
  
      if(result && result.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(result.message)
        dispatch(fetchPresupuestos(currPage, getQuery()));
      }
    } 

    handleCloseInvalidate();
  }
  const handleCloseInvalidate = () => {
    setShowInvalidate(false);
    setCurrentPresupuesto(null);
  }
  
  const handleCloseObservacionComercial = () => {
    setIsOpenObservacionesComercial(false)
    dispatch(fetchPresupuestos(currPage, getQuery()));
  }

  const getPresupuestoRowInfo = (presupuesto, pieza, piezasValues, i) => {
    const envioPieza = presupuesto?.envios?.find(e => e.piezas?.find(p => p.id === pieza.id));
    const servicioEnvioPieza = pieza ? pieza.servicio_envio : null;

    const numero = i === 0 ? <td rowSpan={piezasValues.length + 1} width="6%">
      <span className='d-flex flex-column'>
        <span className="disabled-item" title="Presupuesto" style={{cursor: 'pointer'}} onClick={() =>  handleCopyText(presupuesto)} >
          { presupuesto.es_devolucion.length > 0 && presupuesto.es_devolucion[0].tipo_devolucion_id === 1 ?
            <b className="text-warning">{presupuesto?.numero}</b>
            : presupuesto.es_devolucion.length > 0 && presupuesto.es_devolucion[0].tipo_devolucion_id === 2 ?
            <b className="text-danger">{presupuesto?.numero}</b>
            : presupuesto.factura_proveedor && presupuesto.factura_proveedor?.length > 0 ?
            <b>{presupuesto?.numero}</b>
            : presupuesto?.numero
          }
        </span>
        { presupuesto.ticket_id && <span className='mt-2'>Ticket Nº: {presupuesto.ticket_id}</span>}
      </span>
    </td> : null;

    const fecha = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="12%" className="text-center">
      <div className="w-100 d-flex flex-column">
        <p>{moment(presupuesto.fecha).format("DD-MM-YYYY")}</p>
        <small>CREADO: {moment(presupuesto.created_at).format("DD-MM-YYYY HH:mm")}</small>
        <small>ULT MOD.: {moment(presupuesto.updated_at).format("DD-MM-YYYY HH:mm")}</small>
      </div>
    </td> : null
    const checkout = i === 0 ? 
      <td rowSpan={piezasValues.length + 1} className="text-center">
          <a title="Checkout URL" href={config.recomotor.clientsUrl  + 'checkout/' + presupuesto.checkout_id} target={"_blank"}  className="disabled-item text-green" rel="noreferrer">
            <FontAwesomeIcon icon={faLink} size="1x" className="action" style={{ cursor: 'pointer' }} color="#215732" />
          </a>
          <div style={{height: ".5rem"}} />
          <a title="Plantillas email">
            <FontAwesomeIcon icon={faEnvelope} size="1x" className="action" style={{ cursor: 'pointer' }} color="#215732" onClick={() => handleOpenPlantillasModal(presupuesto)}/>
          </a>
          {(presupuesto?.created_by?.username === 'perito_mutua' && presupuesto?.vale_descuento_id)
            && <>
                <div style={{height: ".5rem"}} />
                <span title='Copiar mensaje descuento aplicado'>
                  <FontAwesomeIcon icon={faCopy} size="1x" className="action" style={{ cursor: 'pointer' }} color={presupuesto?.observaciones_comercial ? "#dc3545" : "#215732"} onClick={() => handleCopyTextCheckoutDiscount(presupuesto)} />
                </span>
                <div style={{height: ".5rem"}} />
                <span title='Observaciones comercial'>
                  <FontAwesomeIcon icon={faCommentDots} size="1x" className="action" style={{ cursor: 'pointer' }} color="#215732" onClick={() => setIsOpenObservacionesComercial(presupuesto)} />
                </span>
              </>}
          {soporte && <>
                <div style={{height: ".5rem"}} />
                <span title='Observaciones comercial'>
                  <FontAwesomeIcon icon={faCommentDots} size="1x" className="action" style={{ cursor: 'pointer' }} color={presupuesto?.observaciones_comercial ? "#dc3545" : "#215732"} onClick={() => setIsOpenObservacionesComercial(presupuesto)} />
                </span>
              </>
          }
      </td> 
    : null
    const cliente = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="12%">
      <Link target="_blank" rel="noopener noreferrer" to={"/cliente/" + presupuesto.cliente?.id} title="Ficha Cliente" className="text-green text-uppercase">
        {presupuesto.cliente?.nombre}
      </Link>
    </td> : null
    const clienteTelf = i === 0 ?  <td rowSpan={piezasValues.length + 1}>{presupuesto.cliente.telefono}</td> : null
    const aceptado = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center"> {presupuesto.expirado ? <FontAwesomeIcon icon={faCross} size="1x" className="action" color="#dc3545" /> : presupuesto.aceptado ? <FontAwesomeIcon icon={faCheck} size="1x" className="action" color="#215732" /> : <FontAwesomeIcon icon={faClock} size="1x" className="action" color="#ffc107" />}</td> : null
    const descuento = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">
    { presupuesto?.vale_descuento ? 
      <div className="d-flex flex-column">
        -{parseFloat(presupuesto.total_descuento_iva > 0 ? presupuesto.total_descuento_iva : presupuesto.total_descuento).toFixed(2)}€
        <small className="fw-bold text-green">{presupuesto?.vale_descuento.codigo}</small>
      </div>
      : '-'
    }
    </td> : null
    const totalIva = i === 0 ? <td rowSpan={piezasValues.length + 1} width="6%" className="text-center">{presupuesto.total_iva}€</td> : null
    const envio = envioPieza ?
        <div className="d-flex flex-column">
          <span onClick={() => handleGoToEnvio(envioPieza)} className="text-green link">{envioPieza.codigo_transporte}</span>
          <small>{envioPieza.transportista_id === 1 ? 'PROVEEDOR' : envioPieza.codigo_envio}</small>
        </div>
        : (servicioEnvioPieza) ?
          <div className="text-uppercase d-flex flex-column">
            <span className="text-green">{servicioEnvioPieza.transportista?.nombre}</span>
            <small style={{fontSize: '10px'}}>{servicioEnvioPieza.servicio_envio?.nombre}</small>
          </div>
        : 
        <div className="d-flex flex-column">
          <small className="text-danger fw-bold text-uppercase">falta envio</small>
        </div>
    const confirmada = pieza ? <span className={"fw-bold " + (pieza.confirmacion === null ? 'text-warning' : (pieza.confirmacion == true ? 'text-green' : 'text-danger'))}>
      {pieza.confirmacion === null ? <FontAwesomeIcon icon={faClock} size="1x" className="action" color="#ffc107" /> : (pieza.confirmacion == true ? 'SI' : 'NO')}
    </span> : null
    const responsable = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center text-uppercase"><small style={{wordBreak: 'break-all'}}>{presupuesto.created_by?.username}</small></td> : null
    const acciones = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center">
      <ActionsMenu 
          options={getActions(presupuesto, user)}
          onAction={(action) => handleAction(action, presupuesto)}
      />
    </td> : null

    return (
      <tr
          className={(((!presupuesto.validado && presupuesto.validacion === null) || (presupuesto.validado && presupuesto.validacion === false) || (presupuesto.validado_integracion === false))) ? "disabled-row" : ""}
          key={'presupuesto-' + presupuesto.id + '-' + i}
          onMouseEnter={(!presupuesto.validado && presupuesto.validacion === null) ? (e => handlePopoverOpen(e, presupuesto)) : null}
          onMouseLeave={(!presupuesto.validado && presupuesto.validacion === null) ? handlePopoverClose : null}
        >
          {numero}
          {fecha}
          {checkout}
          {cliente}
          {clienteTelf}
          { (pieza) ?
            <>
              <td className="border-light" style={{backgroundColor: pieza.disponible === null ? '#fff1ae' : !pieza.disponible ? '#fab3ae' : 'none' }}>
                <div className="w-100 d-flex flex-column text-uppercase">
                  <small className="w-100 d-flex flex-column">
                    <span>
                      {pieza?.presupuesto_relationship?.unidades > 1 ? 
                        <strong>{'x'+pieza?.presupuesto_relationship?.unidades}</strong> : '' 
                      } 
                      {pieza.nombre}
                    </span>
                    <span>REF: <b>{pieza.referencia_pieza}</b></span>
                    { pieza?.casco > 0 ?
                      <span className="fw-bold text-uppercase highlight"><small>contiene casco</small></span>
                      : ''
                    }
                  </small>

                  <Link target="_blank" rel="noopener noreferrer" to={"/proveedor/" + pieza.proveedor?.id} title="Ficha Proveedor" className="text-green text-uppercase">
                    {pieza.proveedor.nombre}
                  </Link>
                </div>
              </td>
              <td className="text-center border-light">
                { (pieza?.url && pieza?.url?.includes('http')) ? 
                  <a href={pieza.url} className="text-green" target={"_blank"} rel="noreferrer">
                    <FontAwesomeIcon icon={faLink}></FontAwesomeIcon>
                  </a>
                  : '-'
                }
              </td>
              <td className="text-center border-light">{parseFloat(pieza.precio_compra).toFixed(2)}€</td>
              <td className="text-center border-light">{parseFloat(pieza.precio_venta).toFixed(2)}€</td>
              <td className="text-center">{pieza.casco > 0 ? parseFloat(pieza.casco).toFixed(2) + '€' : '-'}</td>
            </>
           : 
           <td colSpan={5} className="text-center">No hay piezas</td>
          }
          {descuento}
          {totalIva}
          <td className="text-center border-light">{envio}</td>
          <td className="text-center border-light">{confirmada}</td>
          {aceptado}
          {responsable}
          {acciones}
      </tr>
    )
  }

  const handleOpenPlantillasModal = (presupuesto) => {
    setOpenPlantillaEmail(true);
    setCurrentPresupuesto(presupuesto);
  }

  return (
    <div className="content pt-3">
      <Header  
        viewSearch={true} 
        onSearch={handleSearch}
        onExport={handleOpenExport}
        onEcommerce={handleGoToEcommerce}
        onPresupuesto={handleGoToPresupuestos}
        onTickets={() => setIsTicketsOpen(true)}
        ticketCount={ticketCount}
        onPartNotFound={() => setIsPartNotFoundOpen(true)}
      ></Header>

      <div className="w-100 d-flex flex-column align-items-end content-table presupuestos">
        <div className="w-100 d-flex align-items-center justify-content-between justify-content-md-start mb-3">
          <div className="legend d-flex align-items-center me-md-3">
            <span className="circle" style={{background: '#ffc107'}}></span>
            <p>Devolución parcial</p>
          </div>

          <div className="legend d-flex align-items-center">
            <span className="circle" style={{background: '#dc3545'}}></span>
            <p>Devolución total</p>
          </div>
        </div>
        
        { (presupuestos?.problemas?.length > 0) &&
          <ProblemasList 
          problemas={presupuestos.problemas}
          onMarkAsRead={handleMarkProblemAsRead}
          />
        }

        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Nº</th>
                <th className="text-center">fecha</th>
                <th className="text-center"></th>
                <th>cliente</th>
                <th>telf</th>
                <th><small>Pieza</small></th>
                <th><small>URL</small></th>
                <th className="text-center"><small>compra</small></th>
                <th className="text-center"><small>venta</small></th>
                <th className="text-center"><small>casco</small></th>
                <th className="text-center">descuento</th>
                <th className="text-center">total IVA</th>
                <th className="text-center">Envío</th>
                <th className="text-center">conf</th>
                <th className="text-center">aceptado</th>
                <th className="text-center">resp</th>
                <th className="text-center"></th>
              </tr>
            </thead>
              { 
                presupuestos.presupuestos?.map((presupuesto, index) => {
                  const piezasValues = Object.values(presupuesto.piezas)
                  let piezasRows = piezasValues.map((pieza, i) => {
                    const row = getPresupuestoRowInfo(presupuesto, pieza, piezasValues, i)

                    return (
                      row
                    )
                  })
                  
                  if(piezasRows?.length === 0) {
                    const row = getPresupuestoRowInfo(presupuesto, null, piezasValues, 0)
                    piezasRows =  row
                  }
                  
                  return (
                    <tbody className="border-light" key={presupuesto.id}>
                      {piezasRows}
                    </tbody>
                  )
                }) 
              }
          </table>

          <>
          <Popover
            id="disabledPresupuesto"
            sx={{ pointerEvents: 'none'}}
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            disableRestoreFocus
            classes={{ root: "MuiPopover-root" }}
          >
            <small>
              {(!presupuestoAux.validado && presupuestoAux.validacion === null) ? 
                "Presupuesto pendiente de validar"
                : (!presupuestoAux.validado && !presupuestoAux.validacion) ?
                "Presupuesto NO VALIDADO"
                : ""
              }
            </small>
          </Popover>
          </>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>

      { isDuplicating && 
        <ConfirmModal 
          onConfirmAction={handleConfirmDuplicate} 
          title={'Duplicar presupuesto'}
          description={`Estás seguro de duplicar el presupuesto ${currentPresupuesto.numero}?`}
          state={isDuplicating}>
        </ConfirmModal>
      }
      { (isDisabling) &&
        <ConfirmModal
            onConfirmAction={handleConfirmDisable}
            onClose={() => setIsDisabling(false)}
            title={'Desactivar presupuesto'}
            description={`Estás seguro de desactivar el presupuesto ${currentPresupuesto.numero}?`}
            state={isDisabling}>
        </ConfirmModal>
      }

      { (isReactivating) &&
        <ConfirmModal 
            onConfirmAction={handleConfirmReactivate}
            onClose={() => setIsReactivating(false)}
            title={'Reactivar presupuesto'}
            description={`Estás seguro de reactivar el presupuesto ${currentPresupuesto.numero}?`}
            state={isReactivating}>
        </ConfirmModal>
      }

      { showInvalidate && 
        <ConfirmModal 
          onConfirmAction={handleConfirmInvalidate} 
          title={`Invalidar presupuesto ${currentPresupuesto.numero}`} 
          description={'Estás seguro de invalidar?'}
          state={showInvalidate}>
        </ConfirmModal>
      }

      { showValidate && 
        <ValidacionModal 
          presupuestoId={currentPresupuesto.id}
          onConfirmAction={handleConfirmValidate} 
          onClose={handleCloseValidate}
          state={showValidate}>
        </ValidacionModal>
      }

      { (isOpenExport) && 
        <InfoModal
          state={isOpenExport}
          title="Exportar listado de presupuestos de un cliente"
          content={
            <ExportForm 
              dateFilter={true}
              clienteFilter={true}
              onSubmitExport={handleExportPresupuestosClientes}
            />
          }
          onClose={handleCloseExport}
        ></InfoModal>
      }

      {openPlantillaEmail && (
          <InfoModal
            state={openPlantillaEmail}
            title="Plantillas email"
            content={<PlantillaEmailModal plantillas={plantillasEmail} presupuesto={currentPresupuesto}/>}
            width={"md"}
            onClose={() => setOpenPlantillaEmail(false)}
          />
        )}

        {isOpenObservacionesComercial && 
          <InfoModal
            state={isOpenObservacionesComercial}
            title="Observaciones Comercial"
            content={<ObservacionesComercial presupuesto={isOpenObservacionesComercial} onClose={handleCloseObservacionComercial}/>}
            width={"md"}
            onClose={() => setIsOpenObservacionesComercial(false)}
          />
        }
        
        {isTicketsOpen && 
          <InfoModal
            state={isTicketsOpen}
            title={currentPresupuesto ? "Asignar ticket" : "Tickets pendientes"}
            content={
              <TicketsModal 
                currentPresupuesto={currentPresupuesto}
                onClose={handleCloseAssignTicket}
                currentState={presupuestos}
                />
              }
            width={"lg"}
            onClose={handleCloseAssignTicket}
          />
        }

        { isUnasignTicketOpen &&
          <ConfirmModal 
              onConfirmAction={handleConfirmUnasignTicket}
              onClose={handleCloseUnassignTicket}
              title={'Desasignar ticket'}
              description={`Estás seguro de desasignar el ticket al presupuesto ${currentPresupuesto?.numero}?`}
              state={isUnasignTicketOpen}>
          </ConfirmModal>
        }

        {isPartNotFoundOpen && 
          <InfoModal
            state={isPartNotFoundOpen}
            title={"Pieza no encontrada"}
            content={
              <PartNotFoundModal />
              }
            width={"sm"}
            onClose={() => setIsPartNotFoundOpen(false)}
          />
        }
        
    </div>
  )
}